import React from 'react'
import styled from 'styled-components'
import { colors } from '~/design'
import LoginComponent from './login/login.component'
import { SeoPage } from '~/components/seo'
import TextType from '~/packages/home/login/textType.component'
import FloatingLines from '../../components/backgroundFloatingLines'
import PrixLogo from '~/meta/prixLogo.svg'
import { useMedia } from 'react-use'

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  text-align: center;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #2a2c2e;
`

const Container = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  @media screen and (max-width: 1050px) {
    flex-direction: column-reverse;
    justify-content: space-evenly;
    padding: 20px;
  }
`

const Content = styled.div`
  display: flex;
  height: 100%;
  width: 65%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 65px;
  user-select: none;

  @media (max-width: 1050px) {
    height: auto;
    padding: 20px;
    width: 100%;
  }
`

const LoginContent = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  /* background-color: rgba(42, 44, 46, 0.75); */
  /* backdrop-filter: blur(8px); */
  color: white;
  z-index: 1;

  @media (max-width: 1050px) {
    width: 400px;
    height: 400px;
    flex: none;
  }

  @media (max-width: 768px) {
    width: 100%;
    min-height: 40%;
    height: auto;
  }
`

const TextTypeStyled = styled(TextType)`
  font-size: calc(48px + 4vw);
  font-family: 'Anta', sans-serif;
  font-weight: 400;
  color: white;

  @media (max-width: 1050px) {
    font-size: calc(32px + 4vw);
  }
`

const SubtitleText = styled.div`
  font-size: calc(22px + 0.5vw);
  font-weight: 400;
  color: white;
  margin-top: 10px;

  @media (max-width: 1050px) {
    font-size: calc(12px + 0.5vw);
  }
`

const Footer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  z-index: 1;
  width: 100%;
  background: #0050a0;
  background: linear-gradient(0deg, rgba(0, 80, 160, 1) 0%, rgba(0, 80, 160, 0) 100%);
  color: #fff;
  padding: 50px 20px 20px;
  font-size: 14px;

  @media screen and (max-width: 1050px) {
    align-items: center;
    flex-direction: column;
    text-align: center;
    padding: 50px 10px 10px;
  }
`

const TextFooter = styled.div`
  font-size: 18px;
  text-align: left;
  color: white;

  strong {
    font-size: 24px;
  }

  @media screen and (max-width: 1050px) {
    font-size: 16px;
    padding: 20px 0;
    max-width: 300px;
    text-align: center;

    strong {
      font-size: 20px;
    }

    &:first-of-type {
      border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    }
  }
`

const LinkFooter = styled.a`
  color: white;

  svg {
    height: 30px;
    width: 120px;
  }

  @media screen and (max-width: 1050px) {
    svg {
      height: 25px;
      width: 100px;
    }
  }
`

export default function HomeScreen() {
  const isMobile = useMedia('(max-width: 1050px)')

  return (
    <Wrapper>
      <SeoPage
        title={'MONITOR'}
        url={'https://prixsebrae.com'}
        siteName={'MONITOR'}
        keywords='prix tech, prixsebrae, sebrae, prixneuron, geo, monitor'
        type='website'
      />

      <Container>
        <LoginContent>
          <LoginComponent />
        </LoginContent>
        <Content>
          <TextTypeStyled text='MONITOR' cursorCharacter='_' />
          <SubtitleText>Ambiente de monitoramento de portfólio</SubtitleText>
        </Content>
      </Container>
      <Footer>
        <TextFooter>
          Um projeto
          <br />
          <strong>Unidade de Gestão de Soluções{!isMobile ? ' / ' : <br />}SEBRAE Nacional</strong>
        </TextFooter>
        <TextFooter>
          <LinkFooter href='https://www.prix.tech' target='_blank' rel='noopener noreferrer'>
            <PrixLogo />
          </LinkFooter>
        </TextFooter>
      </Footer>

      <FloatingLines
        enabledWaves={['top', 'middle', 'bottom']}
        lineCount={5}
        lineDistance={5}
        linesGradient={[colors.oceanBlue, colors.sebraeBlue]}
        lineIntensity={1.8}
        middleWaveStrength={0.6}
        bendRadius={5}
        bendStrength={-0.5}
        interactive={true}
        parallax={true}
      />
    </Wrapper>
  )
}
